import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { useSelector } from 'react-redux'
import { selectTransactionNatureList } from '@EUForms/selectors'

export const InvoiceHeader = React.memo(
  ({
    dataSource: {
      totalPackages,
      totalGrossMass,
      totalNetMass,
      totalInvoiceAmountInCurrency,
      totalInvoiceAmount,
      valuationMethod,
      natureOfTransaction,
    },
    onSelect,
    isDisabled
  }) => {
    const natureOfTransactionList = useSelector(selectTransactionNatureList)
    const disabled = true;
    return (
      <Grid className='responsiveGridCss'>
        <Grid.Row>
          <Grid.Column>
            <InputField
              id={`Packages`}
              type='text'
              label='PACKAGES'
              value={totalPackages}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <InputField
              id={`GrossKg`}
              type='text'
              label='GROSS_KG'
              value={totalGrossMass}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <InputField
              id={`NetKg`}
              type='text'
              label='NET_KG'
              value={totalNetMass}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column>
            <InputField
              id="totalInvoiceAmountInCurrency"
              type='text'
              label='TOTAL_INVOICE_VALUE_IN_CURR'
              value={totalInvoiceAmountInCurrency}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column>
            <InputField
              id="totalInvoiceValueInEur"
              type='text'
              label='TOTAL_INVOICE_VALUE_IN_EUR'
              value={totalInvoiceAmount}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
            <Grid.Column>
              <DropDown
                id='valuationMethod'
                label='VALUATION_METHOD'
                labelClass='text-none'
                boxNumber='4/16'
                data={[]}
                clearable
                value={valuationMethod}
                isDisabled={disabled}
              />
            </Grid.Column>
          <Grid.Column>
            <DropDown
              id='natureOfTransaction'
              label='NATURE_OF_TRANSACTION'
              labelClass='text-none'
              boxNumber='8/5'
              direction='left'
              data={natureOfTransactionList}
              value={natureOfTransaction}
              text={natureOfTransaction}
              name='natureOfTransaction'
              isDisabled={isDisabled}
              onChange={onSelect}
              clearable
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
)

